import React from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider, createTheme, StyledEngineProvider } from '@mui/material/styles';
import styled from 'styled-components';
import { store, persistor } from './redux/store';
import { mediaQueries } from './conf/constants/mediaqueries';

import Main from './app/core/Main';
import MessageBoundary from './app/core/MessageBoundary';

const AppWrapper = styled.div`
  display: flex;
  flex: 1;
  min-height: 100%;
`;

const theme = createTheme({
  breakpoints: {
    values: mediaQueries,
    keys: Object.keys(mediaQueries),
  },
});

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={<span>Loading...</span>} persistor={persistor}>
        <Router>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
              <MessageBoundary>
                <AppWrapper>
                  <Main />
                </AppWrapper>
              </MessageBoundary>
            </ThemeProvider>
          </StyledEngineProvider>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
